/* A small, page-local starfield. No libraries, pointer tracking or global theme changes. */
if (!customElements.get('wave-universe-sky')) {
  customElements.define('wave-universe-sky', class extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('canvas');
      this.ctx = this.canvas?.getContext('2d');
      if (!this.ctx) return;
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || this.dataset.motion !== 'true';
      this.button = this.querySelector('button');
      this.time = 0;
      this.last = 0;
      this.stars = Array.from({ length: Math.min(180, Number(this.dataset.density) || 100) }, (_, i) => ({
        x: Math.random(), y: Math.random(), r: .35 + Math.random() * 1.05,
        phase: Math.random() * Math.PI * 2, speed: .3 + Math.random() * .5, sparkle: i % 19 === 0
      }));
      this.resize = () => {
        const box = this.canvas.getBoundingClientRect();
        this.width = box.width; this.height = box.height;
        const scale = Math.min(devicePixelRatio || 1, 2);
        this.canvas.width = this.width * scale; this.canvas.height = this.height * scale;
        this.ctx.setTransform(scale, 0, 0, scale, 0, 0);
        this.draw();
      };
      this.draw = () => {
        const c = this.ctx;
        c.clearRect(0, 0, this.width, this.height);
        for (const s of this.stars) {
          const glow = .3 + .55 * ((Math.sin(this.time * s.speed + s.phase) + 1) / 2);
          const x = s.x * this.width, y = s.y * this.height;
          c.fillStyle = `rgba(235,233,225,${glow})`;
          c.beginPath(); c.arc(x, y, s.r, 0, Math.PI * 2); c.fill();
          if (s.sparkle) {
            c.strokeStyle = `rgba(245,243,235,${glow * .55})`; c.lineWidth = .65;
            const length = 3 + glow * 3;
            c.beginPath(); c.moveTo(x - length, y); c.lineTo(x + length, y);
            c.moveTo(x, y - length); c.lineTo(x, y + length); c.stroke();
          }
        }
      };
      this.frame = now => {
        if (now - this.last > 32) { this.time += Math.min((now - this.last) / 1000, .05); this.last = now; this.draw(); }
        this.raf = requestAnimationFrame(this.frame);
      };
      this.update = () => {
        cancelAnimationFrame(this.raf);
        if (this.button) { this.button.hidden = false; this.button.textContent = this.paused ? this.dataset.play : this.dataset.pause; this.button.setAttribute('aria-pressed', String(this.paused)); }
        if (!this.paused && !document.hidden && this.visible !== false) { this.last = performance.now(); this.raf = requestAnimationFrame(this.frame); }
      };
      this.button?.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, { signal: this.abort.signal });
      document.addEventListener('visibilitychange', this.update, { signal: this.abort.signal });
      this.motion.addEventListener('change', () => { this.paused = this.motion.matches || this.dataset.motion !== 'true'; this.update(); }, { signal: this.abort.signal });
      this.observer = new ResizeObserver(this.resize); this.observer.observe(this.canvas);
      this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); }); this.intersection.observe(this);
      this.resize(); this.update();
    }
    disconnectedCallback() { cancelAnimationFrame(this.raf); this.abort?.abort(); this.observer?.disconnect(); this.intersection?.disconnect(); }
  });
}
